import React,{useState} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faShieldHalved,
  faFileLines,
  faFingerprint,
  faCheckDouble,
} from "@fortawesome/free-solid-svg-icons";


const Section3 = ({url}) => {

  const [activeIndex, setActiveIndex] = useState(0);

const features = [
  {
    icon: "1.png",
    title: "Intelligent Access Control, Structured by Role and Hierarchy",
    desc: "AI-powered policies automatically enforce access permissions across roles, reporting lines, and context—no manual configuration, no human error.",
  },
  {
    icon: "2.png",
    title: "Find Exactly What You Need in Seconds",
    desc: "An AI document management system understands your intent and retrieves the most relevant documents instantly, without endless folder navigation.",
  },
  {
    icon: "3.png",
    title: "Collaborate Freely Without Compromising Control",
    desc: "Comment, discuss, and work together on documents entirely within Concord's intelligent document management environment.",
  },
  {
    icon: "4.png",
    title: "Dual AI Models, Enterprise-Grade Reliability.",
    desc: "Concord runs on a dual AI model architecture, whether processing ten documents or ten thousand, document management performance never wavers.",
  },
  {
    icon: "5.png",
    title: "Starts With Your Team. Scales With Your Enterprise.",
    desc: "Deploy Concord for a single department or roll it out across your entire organization.",
  },
  {
    icon: "6.png",
    title: "Private Infrastructure Deployment for Data Sovereignty",
    desc: "Your documents, your servers, your control, zero third-party cloud dependency, total regulatory compliance.",
  },
];

  return (
   <section className="home-section-3">
    <div className="section3-image-wrapper" data-aos="fade-up">
      <img src={`${url}images/concord/section-3/security.png`} alt="AI Security" className="section3-banner-img" />
    </div>

    <div className="container overflow-hidden">
      <div className="section3-header" data-aos="fade-up">
        <h2 className="section3-title">
          <span className="gradient-text">Intelligence</span> and{" "}
          <span className="gradient-text">Security</span> Working as One
        </h2>
        <p className="section3-subtitle">
          Every feature in our AI document management software is built with a dual purpose: to
          make your team faster and your organization safer.
        </p>
      </div>

      {/* Desktop View */}
      <div className="features-grid desktop-view" data-aos="fade-up" data-aos-delay="200">
        {features.map((item, index) => (
          <div className="feature-card" key={index}>
            <div className="feature-icon-wrapper">
              <img src={`${url}images/concord/section-3/${item.icon}`} alt="" className="feature-icon" />
            </div>
            <h4 className="feature-title" dangerouslySetInnerHTML={{ __html: item.title }} />
            <p className="feature-desc">{item.desc}</p>
          </div>
        ))}
      </div>

      {/* Mobile View */}
      <div className="mobile-view overflow-hidden">
        <div className="tabs">
          {features.map((item, index) => (
            <div
              key={index}
              className={`tab-icon ${activeIndex === index ? "active" : ""}`}
              onClick={() => setActiveIndex(index)}
            >
              <img src={`${url}images/concord/section-3/${item.icon}`} alt="" />
            </div>
          ))}
        </div>

        <div className="tab-content" data-aos="fade-up">
          <h5>{features[activeIndex].title}</h5>
          <p>{features[activeIndex].desc}</p>
        </div>
      </div>

    </div>
  </section>
  );
};

export default Section3;
